<template>
  <div style="padding: 0 24px">
    <StatementForm source="shelvesNumber"></StatementForm>
    <exportBtn></exportBtn>
    <WmsTable :is-pagination="false" :columns="columns"> </WmsTable>
  </div>
</template>

<script>
import StatementForm from "@/views/statement/components/form";
import exportBtn from "@/views/statement/components/exportBtn";
import WmsTable from "@/components/WmsTable";

import { shelvesNumberColums } from "@/views/statement/shelvesNumberColumsData";
export default {
  components: { StatementForm,exportBtn, WmsTable },
  props: {},
  data() {
    return {columns: shelvesNumberColums,};
  },

  created() {},

  methods: {},
};
</script>

<style scoped lang="less"></style>
